import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { ConfigContext } from '../context';

const Icon = (props) => {
  const { config } = useContext(ConfigContext);

  let { alt, icon, className, width, height } = props;

  if(typeof width === 'undefined') {
    width = 21;
  }

  if(typeof height === 'undefined') {
    height = 21;
  }

  // Convert icon name to url
  if (icon.indexOf('/') === -1) {
    icon = `${config.studioUrl}web/assets/${icon}.svg?t=${config.resourceTimestamp}`;
  }

  return <img className={className || 'dealers-icon'} src={icon} alt={alt || ''} width={width} height={height} />;
};

Icon.propTypes = {
  alt: PropTypes.string,
  icon: PropTypes.string,
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default Icon;
